import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../../Api/Api";

export const getAllUsers = createAsyncThunk(
  "users/getall",
  async (params = {}, { rejectWithValue, getState }) => {
    const { auth } = getState();
    const { searchValue, page = 1, limit = 10 } = params;

    // Both listing (no term) and searching (with a term) go through the
    // same category-scoped endpoint — /admin/listUsers and
    // /user/searchUsers never existed server-side.
    let queryParams = new URLSearchParams();
    queryParams.append("page", page);
    queryParams.append("limit", limit);
    if (searchValue) {
      queryParams.append("searchTerm", searchValue);
    }

    const fullUrl = `${baseURL}/category/users?${queryParams.toString()}`;

    try {
      const response = await axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.token}`,
        },
      });

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  allUsers: [],
  pagination: {
    totalNumOfItems: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
  },
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    reset(state) {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload?.data || [];
        state.pagination = {
          totalNumOfItems: action.payload?.totalNumOfItems || 0,
          totalPages: action.payload?.totalPages || 0,
          currentPage: action.payload?.currentPage || 1,
          limit: action.payload?.limit || 10,
        };
        state.error = null;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })

  },
});

export const { reset } = usersSlice.actions;
const usersReducer = usersSlice.reducer;

export default usersReducer;
